import * as THREE from "three";
import { Context } from "../core/context";

import {
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
  ModifyOperateState,
} from "./IModifyOperation";

import { ULabel } from "@/ui/ULabel";
import {
  CommonColor,
  DrawCuttingSymbolHandleAcceptParams,
  DrawCuttingSymbolHandleReturnData,
} from "@/core/Parameters";

class DrawCuttingSymbolModify implements IModifyOperation {
  private m_context: Context;
  private m_orthogonality: boolean;
  private m_locationObject: THREE.Line;
  private m_auxLine: THREE.Line | undefined;
  private m_returnData!: DrawCuttingSymbolHandleReturnData;
  private m_TextLabel: ULabel;
  private m_curPoint: THREE.Vector3 = new THREE.Vector3();
  private m_points: THREE.Vector3[] = [];
  private m_scale: number = 1;
  private m_tempObjectGroup: THREE.Group = new THREE.Group();
  private m_cuttingTempObjectGroup: THREE.Group = new THREE.Group();
  private m_cuttingFirstOrEndTempObjectGroup: THREE.Group = new THREE.Group();
  private m_currentHandlerCuttingTempObject: THREE.LineSegments | undefined;
  private m_cuttingTempObjectBaseLength: number = 0.6;
  private m_firstMatrix: THREE.Matrix4 = new THREE.Matrix4();
  private m_endMatrix: THREE.Matrix4 = new THREE.Matrix4();
  private m_isSelectDir: boolean = false;
  private m_preLine3: THREE.Line3 = new THREE.Line3();
  private m_closePoint: THREE.Vector3 = new THREE.Vector3();
  private m_firstPoints: THREE.Vector3[] = [];
  private m_endPoints: THREE.Vector3[] = [];

  constructor(context: Context, params: DrawCuttingSymbolHandleAcceptParams) {
    this.m_context = context;
    this.m_locationObject = context.ToolsManager.CreatedLocationLine();
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
    this.m_TextLabel = new ULabel(
      this.m_context.ViewManager,
      this.m_context.Dom
    );
    this.m_TextLabel.Visibility = true;
    this.m_context.SceneManager.AuxModel.add(this.m_tempObjectGroup);
    this.m_tempObjectGroup.add(this.m_cuttingTempObjectGroup);
    this.m_tempObjectGroup.add(this.m_cuttingFirstOrEndTempObjectGroup);
    this.m_orthogonality = params.orthogonality;
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {
    this.m_curPoint = point.point.clone();
    this.m_locationObject.position.copy(point.point.clone());
    let TextLabelLocation = new THREE.Vector3();
    TextLabelLocation.x = this.m_curPoint.x + this.m_scale * 35;
    TextLabelLocation.y = this.m_curPoint.y - this.m_scale * 10;
    if (this.m_points.length == 0) {
      this.m_TextLabel.SetVaule(
        "请点取第一个剖切点,按Esc键将退出操作",
        TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
    } else if (this.m_points.length >= 1) {
      if (this.m_orthogonality) {
        let p = point.point.clone();
        this.m_curPoint = this.m_context.ToolsManager.GetOrthogonalityPoint(
          p,
          this.m_points[this.m_points.length - 1]
        );
      }
      if (!this.m_isSelectDir) {
        if (this.m_points.length == 1) {
          this.m_TextLabel.SetVaule(
            "请点取下一个剖切点,按Esc键将退出操作",
            TextLabelLocation,
            new THREE.Vector3(1, 0, 0)
          );
        } else {
          this.m_TextLabel.SetVaule(
            "请点取下一个剖切点或者按空格键开始选择方向,按Esc键将退出操作",
            TextLabelLocation,
            new THREE.Vector3(1, 0, 0)
          );
        }
      } else {
        this.m_TextLabel.SetVaule(
          "请选择方向,按空格键将完成操作,按Esc键将退出操作",
          TextLabelLocation,
          new THREE.Vector3(1, 0, 0)
        );
      }

      this.m_auxLine?.geometry.setFromPoints([
        this.m_points[this.m_points.length - 1],
        this.m_curPoint,
      ]);
      this.m_auxLine?.computeLineDistances();
      this.updateFirstAndCurCuttingTempObject();
      if (this.m_points.length > 1) {
        this.updateCuttingTempObject();
      }
    }
  }
  OnDownPoint(point: DrawOperationMovePointParams): void {
    if (this.m_isSelectDir) {
      return;
    }
    if (this.m_points.length == 0) {
      this.m_points.push(point.point.clone());
      this.m_auxLine = this.m_context.ToolsManager.CreatedAuxLine();
    } else if (this.m_points.length == 1) {
      if (this.m_orthogonality) {
        this.m_points.push(this.m_curPoint.clone());
      } else {
        this.m_points.push(point.point.clone());
      }
    } else {
      this.m_points.push(this.m_closePoint);
    }
    if (this.m_points.length == 1) {
      this.createCuttingFirstOrEndTempObject();
      this.createCuttingFirstOrEndTempObject();
    }

    if (this.m_points.length > 1) {
      this.createCuttingTempObject();
      this.updateCuttingTempObject();
    }
  }
  onKeyDown(e: KeyboardEvent): void {
    e.preventDefault();
    if (e.code == "Space") {
      if (this.m_points.length >= 2) {
        if (!this.m_isSelectDir) {
          this.m_isSelectDir = true;
          let delObj = this.m_cuttingTempObjectGroup.children.pop();
          this.m_context.ToolsManager.ObjectsClear([delObj!]);
        } else {
          this.m_context.ModifyManager.ModifyFinish(
            ModifyOperateState.complete
          );
        }
      }
    }
  }
  onKeyUp(e: KeyboardEvent): void {}

  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    this.m_returnData = {
      points: this.m_points,
      dirPoint: this.m_curPoint,
    };
    this.clear();
    if (operate == ModifyOperateState.complete) {
      return this.m_returnData;
    } else if (operate == ModifyOperateState.cancel) {
      return [];
    }
  }
  OnWheel(e: WheelEvent): void {
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
  }

  onMouseMove(e?: PointerEvent): void {}

  onMouseDown(e: PointerEvent): void {}

  onMouseUp(e: PointerEvent): void {}

  private createCuttingTempObject() {
    let geo = new THREE.BufferGeometry();
    let mat = new THREE.LineBasicMaterial({ color: CommonColor.White });
    let line = new THREE.LineSegments(geo, mat);
    line.frustumCulled = false;
    this.m_currentHandlerCuttingTempObject = line;
    this.m_cuttingTempObjectGroup.add(line);
  }
  private updateCuttingTempObject() {
    let basePoint = this.m_points[this.m_points.length - 1];
    let prePoint = this.m_points[this.m_points.length - 2];
    let v1 = new THREE.Vector3().subVectors(prePoint, basePoint).normalize();
    let v2 = v1.clone().applyAxisAngle(new THREE.Vector3(0, 0, 1), Math.PI / 2);
    let xCross = this.curDir!.clone().cross(v1).z;
    if (xCross > 0) {
      v2 = v1.clone().applyAxisAngle(new THREE.Vector3(0, 0, 1), -Math.PI / 2);
    }
    let p0 = v1
      .clone()
      .setLength(this.m_cuttingTempObjectBaseLength)
      .add(basePoint);
    let p2 = v2
      .clone()
      .setLength(this.m_cuttingTempObjectBaseLength)
      .add(basePoint);
    let points = [p0, basePoint, basePoint, p2];
    this.m_preLine3.set(basePoint, p2);
    this.m_currentHandlerCuttingTempObject?.geometry.setFromPoints(points);
  }

  private createCuttingFirstOrEndTempObject() {
    let geo = new THREE.BufferGeometry();
    let mat = new THREE.LineBasicMaterial({ color: CommonColor.White });
    let line = new THREE.LineSegments(geo, mat);
    line.frustumCulled = false;
    this.m_cuttingFirstOrEndTempObjectGroup.add(line);
  }
  // private updateFirstAndCurCuttingTempObject() {
  //   let firstCuttingTempObject = this.m_cuttingFirstOrEndTempObjectGroup
  //     .children[0] as THREE.LineSegments;
  //   let endCuttingTempObject = this.m_cuttingFirstOrEndTempObjectGroup
  //     .children[1] as THREE.LineSegments;

  //   let firstPoints = [
  //     new THREE.Vector3(0, -0.6, 0),
  //     new THREE.Vector3(0, 0, 0),
  //     new THREE.Vector3(0, 0, 0),
  //     new THREE.Vector3(1, 0, 0),
  //   ];

  //   let EndPoints = [
  //     new THREE.Vector3(0, -0.6, 0),
  //     new THREE.Vector3(0, 0, 0),
  //     new THREE.Vector3(0, 0, 0),
  //     new THREE.Vector3(-1, 0, 0),
  //   ];

  //   let xAxis = new THREE.Vector3(1, 0, 0);
  //   let zAxis = new THREE.Vector3(0, 0, 1);
  //   let xCross = this.curDir!.clone().cross(xAxis).z;

  //   let firstMatrix = new THREE.Matrix4();
  //   let endMatrix = new THREE.Matrix4();
  //   let firstP = this.m_points[0];
  //   let s = new THREE.Vector3(1, 1, 1);
  //   let q = new THREE.Quaternion();
  //   if (!this.m_isSelectDir) {
  //     let endP = this.m_curPoint.clone();
  //     if (this.m_points.length >= 2) {
  //       if (!this.m_orthogonality) {
  //         this.m_preLine3.closestPointToPoint(
  //           this.m_curPoint.clone(),
  //           false,
  //           endP
  //         );
  //       }
  //       this.m_closePoint = endP.clone();
  //     }
  //     let v = new THREE.Vector3()
  //       .subVectors(endP, this.m_points[this.m_points.length - 1])
  //       .normalize();
  //     let angle = v.angleTo(xAxis);
  //     if (v.clone().cross(xAxis).z > 0) {
  //       angle = -angle;
  //     }
  //     q.setFromAxisAngle(zAxis, angle);
  //     firstMatrix.compose(firstP, q, s);
  //     endMatrix.compose(endP, q, s);
  //     if (this.m_points.length < 2) {
  //       this.m_firstMatrix = firstMatrix.clone();
  //     }
  //     let xCross = this.curDir!.clone().cross(v).z;
  //     if (xCross > 0) {
  //     }
  //     firstCuttingTempObject.geometry.setFromPoints([...firstPoints]);
  //     endCuttingTempObject.geometry.setFromPoints([...EndPoints]);
  //     firstCuttingTempObject!.geometry.applyMatrix4(this.m_firstMatrix);
  //     endCuttingTempObject!.geometry.applyMatrix4(endMatrix);
  //   } else {
  //     let endCuttingTempObjectPoints = Array.from(
  //       endCuttingTempObject.geometry.attributes.position.array
  //     );
  //     let endCuttingTempObjectPoint1 = new THREE.Vector3(
  //       endCuttingTempObjectPoints[9],
  //       endCuttingTempObjectPoints[10],
  //       endCuttingTempObjectPoints[11]
  //     );
  //     let endCuttingTempObjectPoint2 = new THREE.Vector3(
  //       endCuttingTempObjectPoints[6],
  //       endCuttingTempObjectPoints[7],
  //       endCuttingTempObjectPoints[8]
  //     );
  //     let endVector = new THREE.Vector3()
  //       .subVectors(endCuttingTempObjectPoint1, endCuttingTempObjectPoint2)
  //       .normalize();
  //     let curVector = new THREE.Vector3()
  //       .subVectors(this.m_curPoint, endCuttingTempObjectPoint2)
  //       .normalize();
  //     if (curVector.clone().cross(endVector).z < 0) {
  //       firstPoints[0] = new THREE.Vector3(0, 0.6, 0);
  //     } else {
  //       EndPoints[0] = new THREE.Vector3(0, 0.6, 0);
  //     }
  //     firstCuttingTempObject.geometry.setFromPoints([...firstPoints]);
  //     endCuttingTempObject.geometry.setFromPoints([...EndPoints]);
  //     firstCuttingTempObject!.geometry.applyMatrix4(this.m_firstMatrix);
  //     endCuttingTempObject!.geometry.applyMatrix4(this.m_endMatrix);
  //   }
  // }
  private updateFirstAndCurCuttingTempObject() {
    let firstCuttingTempObject = this.m_cuttingFirstOrEndTempObjectGroup
      .children[0] as THREE.LineSegments;
    let endCuttingTempObject = this.m_cuttingFirstOrEndTempObjectGroup
      .children[1] as THREE.LineSegments;
    let zAxis = new THREE.Vector3(0, 0, 1);
    if (this.m_points.length <= 1) {
      let firstLineBasePoint = this.m_points[0];
      let firstLineEndP1 = this.m_points[0]
        .clone()
        .add(this.curDir.clone().setLength(1));
      let firstLineEndP2 = this.m_points[0].clone().add(
        this.curDir
          .clone()
          .applyAxisAngle(zAxis, -Math.PI / 2)
          .setLength(0.6)
      );
      this.m_firstPoints = [
        firstLineBasePoint,
        firstLineEndP1,
        firstLineBasePoint,
        firstLineEndP2,
      ];
      let endLineBasePoint = this.m_curPoint;
      let endLineEndP1 = this.m_curPoint
        .clone()
        .add(this.curDir.clone().setLength(1).negate());
      let endLineEndP2 = this.m_curPoint.clone().add(
        this.curDir
          .clone()
          .negate()
          .applyAxisAngle(zAxis, Math.PI / 2)
          .setLength(0.6)
      );
      this.m_endPoints = [
        endLineBasePoint,
        endLineEndP1,
        endLineBasePoint,
        endLineEndP2,
      ];
    } else {
      let endP = this.m_curPoint.clone();
      if (!this.m_orthogonality) {
        this.m_preLine3.closestPointToPoint(
          this.m_curPoint.clone(),
          false,
          endP
        );
      }
      this.m_closePoint = endP.clone();
      let v = new THREE.Vector3().subVectors(
        this.m_firstPoints[1],
        this.m_firstPoints[0]
      );

      let curDirCrossV = this.curDir!.clone().cross(v).z;
      let firstBaseV = this.m_firstPoints[1].clone().sub(this.m_firstPoints[0]);
      let firstLineEndP2 = this.m_points[0].clone().add(
        firstBaseV
          .clone()
          .applyAxisAngle(zAxis, Math.PI / 2)
          .setLength(0.6)
      );
      if (curDirCrossV > 0) {
        firstLineEndP2 = this.m_points[0].clone().add(
          firstBaseV
            .clone()
            .applyAxisAngle(zAxis, -Math.PI / 2)
            .setLength(0.6)
        );
      }
      this.m_firstPoints[3] = firstLineEndP2;
      let v1 = new THREE.Vector3().subVectors(
        this.m_points[this.m_points.length - 1],
        endP
      );
      if (this.m_isSelectDir) {
        if (this.m_points.length % 2 !== 0) {
          this.m_points.pop();
          let delObj = this.m_cuttingTempObjectGroup.children.pop();
          this.m_context.ToolsManager.ObjectsClear([delObj!]);
        }
        endP = this.m_points[this.m_points.length - 1];
        v1 = new THREE.Vector3().subVectors(
          this.m_points[this.m_points.length - 2],
          endP
        );
      }

      let endLineEndP1 = endP.clone().add(v1.clone().setLength(1));
      let endLineEndP2 = endP.clone().add(
        v1
          .clone()
          .applyAxisAngle(zAxis, Math.PI / 2)
          .setLength(0.6)
      );
      let curDirCrossV1 = this.curDir!.clone().cross(v1.clone().negate()).z;
      if (curDirCrossV1 < 0) {
        endLineEndP2 = endP.clone().add(
          v1
            .clone()
            .applyAxisAngle(zAxis, -Math.PI / 2)
            .setLength(0.6)
        );
      }
      this.m_endPoints = [endP, endLineEndP1, endP, endLineEndP2];
    }
    firstCuttingTempObject.geometry.setFromPoints([...this.m_firstPoints]);
    endCuttingTempObject.geometry.setFromPoints([...this.m_endPoints]);
  }

  private clear() {
    this.m_context.ToolsManager.ObjectsClear([
      this.m_locationObject,
      this.m_auxLine!,
    ]);
    this.m_context.ToolsManager.GroupClear(this.m_tempObjectGroup);
    this.m_TextLabel?.dispose();
  }

  private get curDir() {
    return this.m_curPoint.clone().sub(this.m_points[this.m_points.length - 1]);
  }
}

export { DrawCuttingSymbolModify };
